import { Button, Flex, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { Body } from '../../pages/Layouts/Body'

export const SemAcessoResultado: React.FC = () => {
  const nav = useNavigate()

  return (
    <Body isLoading={false}>
      <Flex direction='column' align='center' justify='center' textAlign='center' gap={4} py={20}>
        <Heading size='lg' color='var(--Gray1)'>Acesso não autorizado</Heading>
        <Text maxW='480px' color='var(--Gray2)'>
          Você não possui permissão para visualizar este resultado. Caso acredite que se trata de um engano, entre em contato com o administrador da sua empresa.
        </Text>
        <Button colorScheme='blue' onClick={() => nav('/')}>Voltar para o início</Button>
      </Flex>
    </Body>
  )
}
